<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<h2 mat-dialog-title appLifecycleTracker trackerName="user-group-role-dialog">{{fHeader}}</h2>

<mat-dialog-content>
    <mat-form-field class="user-selection" appearance="outline">
        <mat-label>{{fUser}}</mat-label>
        <mat-select [(ngModel)]="selectedUser" (selectionChange)="onUserChanged()">
            <mat-option *ngFor="let user of users" [value]="user">{{ user.username }}</mat-option>
        </mat-select>
    </mat-form-field>

    <div>{{fGroups}}</div>
    <mat-selection-list class="group-list" [(ngModel)]="selectedRoles">
        <mat-list-option *ngFor="let role of roles" [value]="role.id">{{ role.name }}</mat-list-option>
    </mat-selection-list>
</mat-dialog-content>

<div mat-dialog-actions class="button-wrapper">
    <button mat-raised-button (click)="onCancelClick()" type="button">{{fCancel}}</button>
    <button mat-raised-button (click)="onSubmit()" type="button" color="primary">{{fSave}}</button>
</div>
